// malific 👺
// benefic🌟
// neutral ⚪
// mali-bene  ☯️

const maliBeneNeuMaliBeniEmoji = {
  1: {
    Sun: "🌟",
    Moon: "🌟",
    Mercury: "👺",
    Venus: "⚪",
    Mars: "🌟",
    Jupiter: "☯️",
    Saturn: "⚪",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  2: {
    Sun: "🌟",
    Moon: "👺",
    Mercury: "🌟",
    Venus: "☯️",
    Mars: "👺",
    Jupiter: "⚪",
    Saturn: "🌟",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  3: {
    Sun: "👺",
    Moon: "⚪",
    Mercury: "🌟",
    Venus: "☯️",
    Mars: "👺",
    Jupiter: "⚪",
    Saturn: "🌟",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  4: {
    Sun: "⚪",
    Moon: "🌟",
    Mercury: "👺",
    Venus: "🌟",
    Mars: "🌟",
    Jupiter: "☯️",
    Saturn: "⚪",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  5: {
    Sun: "🌟",
    Moon: "👺",
    Mercury: "⚪",
    Venus: "👺",
    Mars: "🌟",
    Jupiter: "☯️",
    Saturn: "⚪",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  6: {
    Sun: "👺",
    Moon: "⚪",
    Mercury: "🌟",
    Venus: "🌟",
    Mars: "👺",
    Jupiter: "🌟",
    Saturn: "☯️",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  7: {
    Sun: "⚪",
    Moon: "⚪",
    Mercury: "☯️",
    Venus: "🌟",
    Mars: "⚪",
    Jupiter: "👺",
    Saturn: "🌟",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  8: {
    Sun: "⚪",
    Moon: "🌟",
    Mercury: "⚪",
    Venus: "👺",
    Mars: "☯️",
    Jupiter: "🌟",
    Saturn: "☯️",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  9: {
    Sun: "🌟",
    Moon: "⚪",
    Mercury: "⚪",
    Venus: "👺",
    Mars: "☯️",
    Jupiter: "🌟",
    Saturn: "👺",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  10: {
    Sun: "⚪",
    Moon: "⚪",
    Mercury: "☯️",
    Venus: "🌟",
    Mars: "🌟",
    Jupiter: "👺",
    Saturn: "🌟",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  11: {
    Sun: "⚪",
    Moon: "👺",
    Mercury: "🌟",
    Venus: "🌟",
    Mars: "👺",
    Jupiter: "⚪",
    Saturn: "☯️",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
  12: {
    Sun: "👺",
    Moon: "🌟",
    Mercury: "🌟",
    Venus: "👺",
    Mars: "🌟",
    Jupiter: "🌟",
    Saturn: "👺",
    Rahu: "",
    Ketu: "",
    Ascendent: "",
  },
};

export default maliBeneNeuMaliBeniEmoji;
